import { BASE_URL, EXTENSION_REQUEST, GET, } from "../constants";
import { statusParsing, jsonParsing } from "../utils";
import { getAccessToken } from "../../authActions/authActions";

export const fetchExtensionRequestDetail = async (requestId) => {
  const token = await getAccessToken();
  const url = `${BASE_URL}${EXTENSION_REQUEST}/${requestId}`;
  return fetch(url, {
      method: GET,
      headers: {
        "Content-Type": "application/json",
        "userauth" : `bearer ${token}`
      },
    })
    .then(statusParsing)
    .then(jsonParsing);
};
